import {
  ORDER_NUMBER,
  ORDER_NUMBER_EMPTY_TEXT,
  ORDER_NUMBER_INVALID_TEXT,
  POST_CODE,
  POST_CODE_EMPTY_TEXT,
  POST_CODE_INVALID_TEXT,
} from 'features/order-tracker/shared-components/Form/constants';
import { getValidationStatus } from 'features/order-tracker/utils';

import {
  GROUP_ORDER_NUMBER_REG_EXP,
  OCS_ORDER_NUMBER_REG_EXP,
  POSTCODE_REG_EXP,
  SINGLE_ORDER_NUMBER_REG_EXP,
} from './constants';

const selectValidationField = (fieldName: string, value: string): sharedComponents.InputValidationType => {
  switch (fieldName) {
    case POST_CODE:
      return getValidationStatus({
        value,
        errorMassages: {
          emptyValueMessage: POST_CODE_EMPTY_TEXT,
          invalidValueMessage: POST_CODE_INVALID_TEXT,
        },
        validationRegExps: [POSTCODE_REG_EXP],
      });

    case ORDER_NUMBER:
      return getValidationStatus({
        value,
        errorMassages: {
          emptyValueMessage: ORDER_NUMBER_EMPTY_TEXT,
          invalidValueMessage: ORDER_NUMBER_INVALID_TEXT,
        },
        validationRegExps: [SINGLE_ORDER_NUMBER_REG_EXP, GROUP_ORDER_NUMBER_REG_EXP, OCS_ORDER_NUMBER_REG_EXP],
      });
    default:
      return {
        isValid: false,
        errorMassage: '',
      };
  }
};

export const validateForm = (orderNumber: string, postCode: string): sharedComponents.ValidationStatusType => {
  const orderNumberValidationStatusInfo = selectValidationField(ORDER_NUMBER, orderNumber);
  const postCodeValidationStatusInfo = selectValidationField(POST_CODE, postCode);

  return {
    orderNumber: orderNumberValidationStatusInfo,
    postCode: postCodeValidationStatusInfo,
  };
};
